import React, { useState, useEffect, useMemo, useRef } from "react";

import { Box, Typography } from "@mui/material";
import {
  ScheduleJobList4,
  updateBatchStatus,
  ListTransFileRecs,
  UpdateTransFileRecs,
  sendEmail2,
  GetMerchantProfile,
  SendEmailWithAttachment3,
} from "../../util/API/batch";
import {
  CircularProgress,
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { useSelector } from "react-redux";
import PinPad from "../PinPad/PinPad";
import DownloadIcon from "@mui/icons-material/Download";
import { getPortalUsers } from "../../util/API/admin";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions"; // FIX NCS 1989

const PAYROLL_CATEGORY_ID = "33";
const INCORRECT_PIN_ERROR = "INCORRECT_PIN";

const STATUS_OPTIONS = [
  "Open",
  "Review",
  "Approved for Processing",
  "Rejected",
  "Completed",
  "Error",
  "Cancelled",
];

const STATUS_TO_CODE = {
  Open: "-2",
  "Needs Review": "-1",
  "Approved for Processing": "1",
  "Approved for Processing": "0",
  Rejected: "5",
  Completed: "3",
  Error: "2",
  Cancelled: "4",
};

const getDisplayStatus = (code) => {
  const map = {
    "-2": "Open",
    "-1": "Needs Review",
    1: "Approved for Processing",
    0: "Approved for Processing",
    5: "Rejected",
    3: "Completed",
    2: "Error",
    4: "Cancelled",
  };
  return map[code] || `Unknown (${code})`;
};

export default function NcsPayrollReview() {
  const [batches, setBatches] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingIds, setSavingIds] = useState(new Set());
  const [showPinPad, setShowPinPad] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [merchantCompanyName, setCompanyName] = useState("Unknown Company");
  const [pendingRecordSave, setPendingRecordSave] = useState(null);
  const isSubmittingRef = useRef(false);
  const [pinProcessing, setPinProcessing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
    header: "Success",
  });

  const [companyFilter, setCompanyFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  // Record editing state
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [records, setRecords] = useState([]);
  const [recordsLoading, setRecordsLoading] = useState(false);
  const [editingRecId, setEditingRecId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [emailMap, setEmailMap] = useState({});
  const merchantInfo = useSelector((state) => state.login.user);        
  console.log("merchantInfo:", merchantInfo);
  const currentUserId = merchantInfo?.id;
  console.log("currentUserId++++++++++", typeof currentUserId);
  const loggedInUser = JSON.parse(sessionStorage.getItem("user"));
  const loggedInUserEmail =
    loggedInUser?.payload?.body?.Useremailaccount?.emailAccount;
  console.log("Email---------->", loggedInUserEmail);
  //const dispatch = useDispatch();
  let configVariables = useSelector((state) => state.config.baseConfig);
  let isDevEnv = configVariables.devEnvironment;
  let payrollAdminFromEmailId = configVariables.payrollAdminFromEmailId;
  let payrollAdminCCEmailId = configVariables.payrollAdminCCEmailId;
  let payrollEmailFromName = configVariables.payrollEmailFromName;
  console.log("payrollEmailFromName------>", payrollEmailFromName);
  // ====================== TOTAL AMOUNT CALCULATION ======================
  const totalsByCurrency = useMemo(() => {
    const totals = {};

    records.forEach((rec) => {
      let amount = parseFloat(rec.amount) || 0;
      let currency = rec.currency || "CAD";

      // Use live edit values if this record is being edited
      if (rec.id === editingRecId) {
        amount = parseFloat(editForm.amount) || 0;
        currency = editForm.currency || "CAD";
      }

      if (!totals[currency]) totals[currency] = 0;
      totals[currency] += amount;
    });

    return totals;
  }, [records, editingRecId, editForm.amount, editForm.currency]);

  const grandTotal = Object.values(totalsByCurrency).reduce(
    (sum, val) => sum + val,
    0,
  );
  const currencyList = Object.keys(totalsByCurrency);
  const isSingleCurrency = currencyList.length === 1;
  const mainCurrency = isSingleCurrency ? currencyList[0] : null;
  // =====================================================================
  useEffect(() => {
    const fetchCompanyName = async () => {
      if (currentUserId) {
        try {
          const res = await GetMerchantProfile("", currentUserId);
          // console.log("GetMerchantProfile response:", JSON.stringify(res, null, 2));

          if (res?.callStatus === "1") {
            console.log(
              "Merchant profile payload:",
              JSON.stringify(res.payload, null, 2),
            ); // ← ADD THIS

            const businessname =
              res.payload?.Merchant?.businessname || "Unknown Company";
            setCompanyName(
              businessname
                .replace(/&amp;amp;/g, "&")
                .replace(/&amp;#039;/g, "'")
                .replace(/&amp;#39;/g, "'")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#34;/g, "'")
                .replace(/&#039;/g, "'")
                .replace(/&#39;/g, "'")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .trim(),
            );
          }
        } catch (err) {
          console.error("Failed to fetch merchant profile:", err);
        }
      }
    };

    fetchCompanyName();
  }, [currentUserId]);
  const fetchAllPayrollBatches = async () => {
    setLoading(true);
    try {
      const response = await ScheduleJobList4({
        categoryid: PAYROLL_CATEGORY_ID,
        rows: 1000,
      });

      if (response.callStatus === "1") {
        let raw = response.payload?.record || [];
        if (!Array.isArray(raw)) raw = raw ? [raw] : [];

        // const usersResponse = await getPortalUsers();
        // const userList = usersResponse?.payload || [];
        // const usersArray = Array.isArray(userList) ? userList : userList ? [userList] : [];
        const usersResponse = await getPortalUsers();
        const rawPayload = usersResponse?.payload || [];

        let usersArray = [];
        if (Array.isArray(rawPayload)) {
          usersArray = rawPayload; // v7
        } else if (Array.isArray(rawPayload?.record)) {
          usersArray = rawPayload.record; // v2
        } else if (rawPayload && typeof rawPayload === "object") {
          usersArray = [rawPayload];
        }
        const companyMap = {};
        const emailMapTemp = {};
        const eligibleRoleIds = [
          configVariables.payRollAdminId,
          configVariables.associatePayrollAdminId, // add this to config
        ];
        console.log(usersArray, "usersArray");
        usersArray.forEach((user) => {
          const roles = Array.isArray(user.Securityuserrole)
            ? user.Securityuserrole
            : [user.Securityuserrole];
          if (
            roles.some((role) => eligibleRoleIds.includes(role.roleid)) &&
            user.Vuser?.id
          ) {
            emailMapTemp[user.Vuser.id] = user.Vuser.other1?.trim() || "unknown";
          }
        });

        setEmailMap(emailMapTemp);

        // Collect unique user IDs
        const uniqueUserIds = [
          ...new Set(
            raw
              .map((item) => item.Scheduleinstance.requestuserid)
              .filter(Boolean),
          ),
        ];

        // Fetch profiles in parallel
        const profiles = await Promise.all(
          uniqueUserIds.map(async (uid) => {
            try {
              const res = await GetMerchantProfile("", uid);
              // console.log(`GetMerchantProfile response for userid ${uid}:`, JSON.stringify(res, null, 2));
              return { userid: uid, profile: res };
            } catch (err) {
              console.error(`Failed to fetch profile for userid ${uid}:`, err);
              return { userid: uid, profile: null };
            }
          }),
        );

        profiles.forEach((p) => {
          if (p.profile?.callStatus === "1") {
            const businessname =
              p.profile.payload?.Merchant?.businessname || "Unknown Company";
            companyMap[p.userid] = businessname
              .replace(/&amp;amp;/g, "&")
              .replace(/&amp;#039;/g, "'")
              .replace(/&amp;#39;/g, "'")
              .replace(/&amp;/g, "&")
              .replace(/&quot;/g, '"')
              .replace(/&#34;/g, '"')
              .replace(/&#039;/g, "'")
              .replace(/&#39;/g, "'")
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">")
              .trim();
          } else {
            companyMap[p.userid] = "Unknown Company";
          }
        });

        const mapped = raw
          .map((item) => {
            const s = item.Scheduleinstance;
            const recordsMatch = s.notes?.match(/records:\s*(\d+)/i);
            const totalRecords = recordsMatch
              ? parseInt(recordsMatch[1], 10)
              : 0;

            const cleanNotes = s.notes
              ? decodeHtmlEntities(s.notes)
                  .replace(/&amp;amp;/g, "&")
                  .replace(/&amp;#039;/g, "'")
                  .replace(/&amp;#39;/g, "'")
                  .replace(/&amp;/g, "&")
                  .replace(/&quot;/g, '"')
                  .replace(/&#39;/g, "'")
                  .replace(/&lt;/g, "<")
                  .replace(/&gt;/g, ">")
                  .replace(/&nbsp;/g, " ")
                  .split("\n")
                  .filter(Boolean)
                  .join(" • ")
              : "—";

            return {
              id: s.requestid,
              agentId: s.requestuserid,
              fileName: s.inputfilename,
              records: totalRecords,
              uploadedAt: s.requesttime || "—",
              notes: cleanNotes,
              status: getDisplayStatus(s.executionstatus),
              rawStatus: s.executionstatus,
              companyName: companyMap[s.requestuserid] || "Unknown Company",
              scheduledTime: s.scheduletime || "—",
              totalAmount: parseFloat(s.amount) || 0, // ← NEW
              totalAmountDisplay: parseFloat(s.amount)
                ? parseFloat(s.amount).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })
                : "—", // ← NEW (simple)
            };
          })
          .filter((batch) =>
            ["-1", "5", "0", "1", "4", "2", "3"].includes(batch.rawStatus),
          );

        setBatches(mapped);
        setFilteredBatches(mapped);
      } else {
        setBatches([]);
        setFilteredBatches([]);
      }
    } catch (err) {
      console.error("Failed to load batches:", err);
      setBatches([]);
      setFilteredBatches([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshBatches = async () => {
    setLoading(true);
    setShowPinPad(false);
    await fetchAllPayrollBatches();
    setLoading(false);
  };

  useEffect(() => {
    fetchAllPayrollBatches();
  }, []);

  useEffect(() => {
    let filtered = [...batches];

    if (companyFilter !== "all") {
      filtered = filtered.filter((b) => b.companyName === companyFilter);
    }

    if (statusFilter !== "all") {
      filtered = filtered.filter((b) => b.status === statusFilter);
    }

    setFilteredBatches(filtered);
  }, [companyFilter, statusFilter, batches]);

  const openRecordEditor = async (batch) => {
    setSelectedBatch(batch);
    setRecords([]);
    setEditingRecId(null);
    setRecordsLoading(true);

    try {
      const res = await ListTransFileRecs(batch.id);

      if (res.callStatus !== "1") {
        setAlert({
          open: true,
          severity: "error",
          header: "Access Denied",
          message: "Cannot load records for this batch.",
        });
        setRecordsLoading(false);
        return;
      }

      const raw = res.payload?.record || null;
      let rawArray = [];

      if (raw) {
        if (Array.isArray(raw)) {
          rawArray = raw;
        } else {
          rawArray = [raw];
        }
      }

      if (rawArray.length === 0) {
        setAlert({
          open: true,
          severity: "info",
          header: "Empty Batch",
          message: "No records found in this batch.",
        });
        setRecords([]);
        setRecordsLoading(false);
        return;
      }

      const allRecords = rawArray
        .map((item) => item?.Transfilerecs)
        .filter(Boolean);

      if (allRecords.length === 0) {
        setAlert({
          open: true,
          severity: "warning",
          header: "No Data",
          message: "Records exist but structure is empty.",
        });
        setRecords([]);
        setRecordsLoading(false);
        return;
      }

      const mapped = allRecords.map((r) => ({
        id: r.recid,
        recid: r.recid,
        requestid: r.requestid,
        firstname: r.firstname?.trim() || "",
        lastname: r.lastname?.trim() || "",
        email: r.email?.trim() || "",
        amount: r.amount || "0.00",
        currency: r.currency || "CAD",
        phoneno: r.phoneno || "",
        address1: r.address1 || "",
        address2: r.address2 || "",
        country: r.country || "CA",
        state: r.state || "",
        zipcode: r.zipcode || "",
        birthdate: r.birthdate === "0000-00-00" ? "" : r.birthdate,
        comment: decodeHtmlEntities(r.comment) || "", // FIX NCS 1989
        purposeofaccount: r.purposeofaccount || "",
        status: r.status === "0" ? "Pending" : r.status || "Pending",
        errormessage: r.errormessage || "",
      }));

      setRecords(mapped);
      setRecordsLoading(false);

      // ────── Total Amount for main table (calculated once when records are loaded) ──────
      const totals = {};
      mapped.forEach((rec) => {
        const amt = parseFloat(rec.amount) || 0;
        const cur = rec.currency || "CAD";
        totals[cur] = (totals[cur] || 0) + amt;
      });
      // AFTER
const currencyKeys = Object.keys(totals);
const display =
  currencyKeys.length === 0
    ? "—"
    : currencyKeys.length === 1
    ? totals[currencyKeys[0]].toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : currencyKeys
        .map(
          (c) =>
            `${totals[c].toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${c}`
        )
        .join(" + ");
      // setBatches((prev) =>
      //   prev.map((b) =>
      //     b.id === batch.id ? { ...b, totalAmountDisplay: display } : b,
      //   ),
      // );
      setBatches((prev) =>
  prev.map((b) =>
    b.id === batch.id && !b.totalAmountDisplay
      ? { ...b, totalAmountDisplay: display }
      : b,
  ),
);
      // ──────────────────────────────────────────────────────────────────────────────────
    } catch (err) {
      console.error("Failed to load records:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Load Failed",
        message: "Error loading batch records.",
      });
      setRecordsLoading(false);
    }
  };

  const startEdit = (record) => {
    setEditingRecId(record.id);
    setEditForm({ ...record });
  };

  // const saveRecord = async () => {
  //   try {
  //     const statusCodeMap = {
  //       Pending: "0",
  //       CORRECTED: "1",
  //       ERROR: "2",
  //     };

  //     const payloadToSend = {
  //       ...editForm,
  //       status: statusCodeMap[editForm.status] || editForm.status || "0",
  //     };

  //     const result = await UpdateTransFileRecs(payloadToSend);

  //     if (result.callStatus === "1") {
  //       setRecords((prev) =>
  //         prev.map((r) => (r.recid === editForm.recid ? { ...editForm } : r)),
  //       );
  //       setEditingRecId(null);
  //       setAlert({
  //         open: true,
  //         severity: "success",
  //         header: "Saved!",
  //         message: "Record updated successfully.",
  //       });
  //     } else {
  //       throw new Error();
  //     }
  //   } catch (err) {
  //     console.error("Save failed:", err);
  //     setAlert({
  //       open: true,
  //       severity: "error",
  //       header: "Save Failed",
  //       message: "Could not update record. Check console.",
  //     });
  //   }
  // };

// const saveRecord = async () => {
//   try {
//     const statusCodeMap = {
//       Pending: "0",
//       CORRECTED: "1",
//       ERROR: "2",
//     };

//     const payloadToSend = {
//       ...editForm,
//       status: statusCodeMap[editForm.status] || editForm.status || "0",
//     };

//     const result = await UpdateTransFileRecs(payloadToSend);

//     if (result.callStatus === "1") {
//       const updatedRecords = records.map((r) =>
//         r.recid === editForm.recid ? { ...editForm } : r
//       );

//       setRecords(updatedRecords);
//       setEditingRecId(null);

//       // ✅ Recalculate totals from updated records and sync to batch list
//       const newTotals = {};
//       updatedRecords.forEach((rec) => {
//         const amt = parseFloat(rec.amount) || 0;
//         const cur = rec.currency || "CAD";
//         newTotals[cur] = (newTotals[cur] || 0) + amt;
//       });

//      // AFTER — only show currency label if there are multiple currencies
// const currencyKeys = Object.keys(newTotals);
// const newDisplay =
//   currencyKeys.length === 0
//     ? "—"
//     : currencyKeys.length === 1
//     ? newTotals[currencyKeys[0]].toLocaleString("en-US", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//       }) // single currency — no label, matches original format
//     : currencyKeys
//         .map(
//           (c) =>
//             `${newTotals[c].toLocaleString("en-US", {
//               minimumFractionDigits: 2,
//               maximumFractionDigits: 2,
//             })} ${c}` // multi-currency — show label
//         )
//         .join(" + ");
//       // ✅ Update the batch row in the list
//       setBatches((prev) =>
//         prev.map((b) =>
//           b.id === selectedBatch.id
//             ? { ...b, totalAmountDisplay: newDisplay }
//             : b
//         )
//       );

//       setAlert({
//         open: true,
//         severity: "success",
//         header: "Saved!",
//         message: "Record updated successfully.",
//       });
//     } else {
//       throw new Error();
//     }
//   } catch (err) {
//     console.error("Save failed:", err);
//     setAlert({
//       open: true,
//       severity: "error",
//       header: "Save Failed",
//       message: "Could not update record. Check console.",
//     });
//   }
// };
const saveRecord = () => {
    // ── VALIDATION ──
  if (!["1", "2", "3"].includes(String(editForm.purposeofaccount))) {
    setAlert({
      open: true,
      severity: "error",
      header: "Invalid Value",
      message: "Purpose of Account must be 1, 2, or 3.",
    });
    return; // stop here — don't show PIN pad
  }
  const statusCodeMap = {
    Pending: "0",
    CORRECTED: "1",
    ERROR: "2",
  };

  const payloadToSend = {
    ...editForm,
    status: statusCodeMap[editForm.status] || editForm.status || "0",
  };

  const updatedRecords = records.map((r) =>
    r.recid === editForm.recid ? { ...editForm } : r
  );

  const newTotals = {};
  updatedRecords.forEach((rec) => {
    const amt = parseFloat(rec.amount) || 0;
    const cur = rec.currency || "CAD";
    newTotals[cur] = (newTotals[cur] || 0) + amt;
  });
  const newGrandTotal = Object.values(newTotals).reduce(
    (sum, v) => sum + v,
    0
  );

  const currencyKeys = Object.keys(newTotals);
  const newDisplay =
    currencyKeys.length === 0
      ? "—"
      : currencyKeys.length === 1
      ? newTotals[currencyKeys[0]].toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : currencyKeys
          .map(
            (c) =>
              `${newTotals[c].toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${c}`
          )
          .join(" + ");

  // Stash everything and show PIN pad
  setPendingRecordSave({
    payloadToSend,
    updatedRecords,
    newGrandTotal,
    newDisplay,
  });
  setShowPinPad(true);
};
  const requestStatusChange = (id, newStatus) => {
    const current = batches.find((b) => b.id === id)?.status;
    if (newStatus === current) return;

    if (newStatus === "Rejected") {
      // Show rejection modal for reason
      setPendingAction({ id, newStatus });
      setRejectionReason(""); // Reset reason
      setRejectModalOpen(true);
    } else {
      // Normal flow for other statuses
      setPendingAction({ id, newStatus });
      setShowPinPad(true);
    }
  };

  //   const handlePinConfirm = async (event, pinArray) => {

  //     if (!pendingAction || !Array.isArray(pinArray)) {
  //       setShowPinPad(false);
  //       setPendingAction(null);
  //       return;
  //     }

  //     const PIN = pinArray.join("");
  //     const { id, newStatus } = pendingAction;
  //     const original = batches.find((b) => b.id === id);

  //     // Optimistic UI update
  //     setBatches((prev) =>
  //       prev.map((b) => (b.id === id ? { ...b, status: newStatus } : b))
  //     );
  //     setSavingIds((prev) => new Set(prev).add(id));

  //     let isPinError = false;

  //     try {
  //       let finalNotes = "";

  //       if (newStatus === "Rejected" && rejectionReason.trim()) {
  //         finalNotes = `Rejection Reason: ${rejectionReason.trim()}`;
  //       } else if (newStatus === "Approved for Processing") {
  //         finalNotes = `Approved for processing on ${new Date().toLocaleString()}`;
  //       } else if (newStatus === "Cancelled") {
  //         finalNotes = `Cancelled on ${new Date().toLocaleString()}`;
  //       }

  //       const original = batches.find((b) => b.id === id);

  //       const result = await updateBatchStatus({
  //         requestid: id,
  //         executionstatus: STATUS_TO_CODE[newStatus],
  //         notes: finalNotes,
  //         pin: PIN,
  //         requestuserid: currentUserId,
  //         amount: original?.totalAmount || 0
  //       });

  //       if (
  //         result.callStatus !== "1" &&
  //         (
  //           result?.payload?.msg?.toLowerCase().includes("pin") ||
  //           result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
  //           result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
  //           (result?.payload?.callStatus === "0" && result?.payload?.msg?.includes("authentication"))
  //         )
  //       ) {
  //         throw new Error("INCORRECT_PIN");
  //       }

  //       if (result.callStatus !== "1") {
  //         throw new Error("Failed to update status");
  //       }

  //       await refreshBatches();

  //       let message = `Batch #${id} → ${newStatus}`;

  //       if (newStatus === "Approved for Processing" || newStatus === "Rejected") {
  //         const submitterEmail = emailMap[original?.agentId];
  //         let subject = "";
  //         let emailText = "";

  //         if (newStatus === "Approved for Processing") {
  //           subject = `Payroll Batch #${id} Approved for Processing`;
  //           emailText = `PAYROLL BATCH APPROVED FOR PROCESSING\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(original?.fileName, original?.companyName)}\nRecords: ${original?.records}\nCompany: ${original?.companyName}\nScheduled Time: ${original?.scheduledTime}\n\n— NCS Payroll Service`;
  //         } else if (newStatus === "Rejected") {
  //           subject = `Payroll Batch #${id} Rejected`;
  //           emailText = `PAYROLL BATCH REJECTED\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(original?.fileName,  original?.companyName)}\nRecords: ${original?.records}\nCompany: ${original?.companyName}\nRejection Reason: ${rejectionReason || "No reason provided"}\n\n— NCS Payroll Service`;
  //         }

  //     try {
  //   const emailRes = await SendEmailWithAttachment2({
  //     userid: currentUserId,
  //     from: loggedInUserEmail || "no-reply@4pay.ca", // ← logged-in user's email
  //     recipient: submitterEmail,
  //     cc: loggedInUserEmail  || "no-reply@4pay.ca",
  //     subject,
  //     emailText,
  //     attachedfilename: ""
  //   });

  //   // ← Surface backend response in alert (success or error)
  //   // const backendMsg = emailRes?.payload?.msg || emailRes?.message || "";
  //   if (emailRes?.callStatus === "1") {
  //     setAlert({
  //       open: true,
  //       severity: "success",
  //       header: "Email Sent",
  //       message:`Notification sent to ${submitterEmail}`
  //     });
  //   } else {
  //     setAlert({
  //       open: true,
  //       severity: "error",
  //       header: "Email Failed",
  //       message:  "Email could not be sent. Please check the recipient address."
  //     });
  //   }
  // } catch (e) {
  //   console.error("Email send error:", e);
  //   setAlert({
  //     open: true,
  //     severity: "error",
  //     header: "Email Error",
  //     message: e?.message || "An unexpected error occurred while sending the email."
  //   });
  // }
  //       }

  //       setAlert({
  //         open: true,
  //         severity: "success",
  //         header: "Success",
  //         message,
  //       });
  //     } catch (error) {
  //       if (error.message === "INCORRECT_PIN") {
  //         isPinError = true;
  //         setAlert({
  //           open: true,
  //           severity: "error",
  //           header: "Incorrect PIN",
  //           message: "The PIN you entered is wrong. Please try again."
  //         });

  //         setBatches((prev) =>
  //           prev.map((b) => (b.id === id ? original : b))
  //         );

  //         setShowPinPad(true);
  //         return;
  //       }

  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Failed",
  //         message: "Status update failed."
  //       });
  //       setBatches((prev) =>
  //         prev.map((b) => (b.id === id ? original : b))
  //       );
  //     } finally {
  //       setSavingIds((prev) => {
  //         const s = new Set(prev);
  //         s.delete(id);
  //         return s;
  //       });

  //       if (!isPinError) {
  //         setShowPinPad(false);
  //         setPendingAction(null);
  //         setRejectionReason("");
  //       }
  //     }
  //   };
  // const handlePinConfirm = async (event, pinArray) => {

  //   if (!pendingAction || !Array.isArray(pinArray)) {
  //     setShowPinPad(false);
  //     setPendingAction(null);
  //     return;
  //   }

  //   const PIN = pinArray.join("");
  //   const { id, newStatus } = pendingAction;
  //   const original = batches.find((b) => b.id === id);

  //   // Optimistic UI update
  //   setBatches((prev) =>
  //     prev.map((b) => (b.id === id ? { ...b, status: newStatus } : b)),
  //   );
  //   setSavingIds((prev) => new Set(prev).add(id));

  //   let isPinError = false;

  //   try {
  //     let finalNotes = "";

  //     if (newStatus === "Rejected" && rejectionReason.trim()) {
  //       finalNotes = `Rejection Reason: ${rejectionReason.trim()}`;
  //     } else if (newStatus === "Approved for Processing") {
  //       finalNotes = `Approved for processing on ${new Date().toLocaleString()}`;
  //     } else if (newStatus === "Cancelled") {
  //       finalNotes = `Cancelled on ${new Date().toLocaleString()}`;
  //     }

  //     const original = batches.find((b) => b.id === id);
  //     console.log("original------->", original);
  //     const result = await updateBatchStatus({
  //       requestid: id,
  //       executionstatus: STATUS_TO_CODE[newStatus],
  //       notes: finalNotes,
  //       pin: PIN,
  //       requestuserid: currentUserId,
  //       amount: original?.totalAmount || 0,
  //       uploadedby: original?.agentId,
  //       approvedby: currentUserId,
  //       lastuserid: currentUserId,
  //     });

  //     if (
  //       result.callStatus !== "1" &&
  //       (result?.payload?.msg?.toLowerCase().includes("pin") ||
  //         result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
  //         result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
  //         (result?.payload?.callStatus === "0" &&
  //           result?.payload?.msg?.includes("authentication")))
  //     ) {
  //       throw new Error("INCORRECT_PIN");
  //     }

  //     if (result.callStatus !== "1") {
  //       throw new Error("Failed to update status");
  //     }

  //     await refreshBatches();

  //     let emailStatusMsg = ""; // ← collect email result here

  //     if (newStatus === "Approved for Processing" || newStatus === "Rejected") {
  //       const submitterEmail = emailMap[original?.agentId];
  //       let subject = "";
  //       let emailText = "";

  //       if (newStatus === "Approved for Processing") {
  //         subject = `Payroll Batch #${id} Approved for Processing`;
  //         emailText = `PAYROLL BATCH APPROVED FOR PROCESSING\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(original?.fileName, original?.companyName)}\nRecords: ${original?.records}\nCompany: ${original?.companyName}\nScheduled Time: ${original?.scheduledTime}\n\n— NCS Payroll Service`;
  //       } else if (newStatus === "Rejected") {
  //         subject = `Payroll Batch #${id} Rejected`;
  //         emailText = `PAYROLL BATCH REJECTED\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(original?.fileName, original?.companyName)}\nRecords: ${original?.records}\nCompany: ${original?.companyName}\nRejection Reason: ${rejectionReason || "No reason provided"}\n\n— NCS Payroll Service`;
  //       }

  //       try {
  //         const emailRes = await SendEmailWithAttachment3({
  //           userid: currentUserId,
  //           from: payrollAdminFromEmailId,
  //           recipient: submitterEmail,
  //           cc: payrollAdminCCEmailId,
  //           subject,
  //           emailText,
  //           attachedfilename: "",
  //           fromname: payrollEmailFromName,
  //         });

  //         // Normalize response
  //         const isSuccess = emailRes?.data?.header?.callStatus === "1";

  //         const isFailure = emailRes?.payload?.callStatus !== "1";

  //         if (isSuccess) {
  //           emailStatusMsg = `Notification sent to ${submitterEmail}.`;
  //         } else if (isFailure) {
  //           const errorMsg = emailRes?.payload?.msg || "Failed to send email.";

  //           emailStatusMsg = `Email failed: ${errorMsg}`;
  //         } else {
  //           // Unknown structure fallback
  //           emailStatusMsg = `Email status unknown for ${submitterEmail}.`;
  //         }
  //       } catch (e) {
  //         console.error("Email send error:", e);
  //         emailStatusMsg = `Email error: ${e?.message || "Unexpected error."}`;
  //       }
  //     }

  //     // ← Single combined alert shown once, after everything is done
  //     setAlert({
  //       open: true,
  //       severity: "success",
  //       header: "Success",
  //       message: `Batch #${id} → ${newStatus}.${emailStatusMsg ? ` ${emailStatusMsg}` : ""}`,
  //     });
  //   } catch (error) {
  //     if (error.message === "INCORRECT_PIN") {
  //       isPinError = true;
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Incorrect PIN",
  //         message: "The PIN you entered is wrong. Please try again.",
  //       });

  //       setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));

  //       setShowPinPad(true);
  //       return;
  //     }

  //     setAlert({
  //       open: true,
  //       severity: "error",
  //       header: "Failed",
  //       message: "Status update failed.",
  //     });
  //     setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
  //   } finally {
  //     setSavingIds((prev) => {
  //       const s = new Set(prev);
  //       s.delete(id);
  //       return s;
  //     });

  //     if (!isPinError) {
  //       setShowPinPad(false);
  //       setPendingAction(null);
  //       setRejectionReason("");
  //     }
  //   }
  // };
  const handlePinConfirm = async (event, pinArray) => {
     if (isSubmittingRef.current) {
    console.warn("handlePinConfirm already in progress — ignoring duplicate call");
    return;
  }
  isSubmittingRef.current = true;
  setPinProcessing(true);
  try {
    if (!Array.isArray(pinArray)) {
    setShowPinPad(false);
    setPendingAction(null);
    setPendingRecordSave(null);
    return;
  }

  const PIN = pinArray.join("");

  // ── RECORD SAVE WITH BATCH TOTAL SYNC ──
  if (pendingRecordSave) {
    const { payloadToSend, updatedRecords, newGrandTotal, newDisplay } =
      pendingRecordSave;
    let isPinError = false;

    try {
      const recordResult = await UpdateTransFileRecs(payloadToSend);
      if (recordResult.callStatus !== "1")
        throw new Error("Failed to save record");

      const batchResult = await updateBatchStatus({
        requestid: selectedBatch.id,
        executionstatus: selectedBatch.rawStatus,
        notes: selectedBatch.notes || "",
        pin: PIN,
        requestuserid: currentUserId,
        amount: newGrandTotal,
        uploadedby: selectedBatch.agentId,
        approvedby: currentUserId,
        lastuserid: currentUserId,
        scheduletime:
          selectedBatch.scheduledTime !== "—"
            ? selectedBatch.scheduledTime
            : undefined,
      });

      if (
        batchResult.callStatus !== "1" &&
        (batchResult?.payload?.msg?.toLowerCase().includes("pin") ||
          batchResult?.payload?.msg?.toLowerCase().includes("invalid pin") ||
          batchResult?.payload?.msg?.toLowerCase().includes("incorrect pin"))
      ) {
        throw new Error(INCORRECT_PIN_ERROR);
      }

      if (batchResult.callStatus !== "1")
        throw new Error("Failed to sync batch total");

      setRecords(updatedRecords);
      setEditingRecId(null);

      setBatches((prev) =>
        prev.map((b) =>
          b.id === selectedBatch.id
            ? {
                ...b,
                totalAmount: newGrandTotal,
                totalAmountDisplay: newDisplay,
              }
            : b
        )
      );

      setSelectedBatch((prev) => ({
        ...prev,
        totalAmount: newGrandTotal,
      }));

      setAlert({
        open: true,
        severity: "success",
        header: "Saved!",
        message: "Record updated and batch total synced successfully.",
      });
    } catch (error) {
      if (error.message === INCORRECT_PIN_ERROR) {
        isPinError = true;
        setAlert({
          open: true,
          severity: "error",
          header: "Incorrect PIN",
          message: "The PIN you entered is wrong. Please try again.",
        });
        setShowPinPad(true);
        return;
      }
      setAlert({
        open: true,
        severity: "error",
        header: "Failed",
        message: error.message || "Could not save record.",
      });
    } finally {
      if (!isPinError) {
        setShowPinPad(false);
        setPendingRecordSave(null);
      }
    }
    return;
  }

  // ── STATUS CHANGE ──
  if (pendingAction) {
    const { id, newStatus } = pendingAction;
    const original = batches.find((b) => b.id === id);

    // Optimistic UI update
    setBatches((prev) =>
      prev.map((b) => (b.id === id ? { ...b, status: newStatus } : b))
    );
    setSavingIds((prev) => new Set(prev).add(id));

    let isPinError = false;

    try {
      let finalNotes = "";

      if (newStatus === "Rejected" && rejectionReason.trim()) {
        finalNotes = `Rejection Reason: ${rejectionReason.trim()}`;
      } else if (newStatus === "Approved for Processing") {
        finalNotes = `Approved for processing on ${new Date().toLocaleString()}`;
      } else if (newStatus === "Cancelled") {
        finalNotes = `Cancelled on ${new Date().toLocaleString()}`;
      }

      const result = await updateBatchStatus({
        requestid: id,
        executionstatus: STATUS_TO_CODE[newStatus],
        notes: finalNotes,
        pin: PIN,
        requestuserid: currentUserId,
        amount: original?.totalAmount || 0,
        uploadedby: original?.agentId,
        approvedby: currentUserId,
        lastuserid: currentUserId,
      });

      if (
        result.callStatus !== "1" &&
        (result?.payload?.msg?.toLowerCase().includes("pin") ||
          result?.payload?.msg?.toLowerCase().includes("invalid pin") ||
          result?.payload?.msg?.toLowerCase().includes("incorrect pin") ||
          (result?.payload?.callStatus === "0" &&
            result?.payload?.msg?.includes("authentication")))
      ) {
        throw new Error(INCORRECT_PIN_ERROR);
      }

      if (result.callStatus !== "1")
        throw new Error("Failed to update status");

      await refreshBatches();

      let emailStatusMsg = "";

      if (newStatus === "Approved for Processing" || newStatus === "Rejected") {
        const submitterEmail = emailMap[original?.agentId];
        let subject = "";
        let emailText = "";

        if (newStatus === "Approved for Processing") {
          subject = `Payroll Batch #${id} Approved for Processing`;
          emailText = `PAYROLL BATCH APPROVED FOR PROCESSING\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(original?.fileName, original?.companyName)}\nRecords: ${original?.records}\nCompany: ${original?.companyName}\nScheduled Time: ${original?.scheduledTime}\n\n— NCS Payroll Service`;
        } else if (newStatus === "Rejected") {
          subject = `Payroll Batch #${id} Rejected`;
          emailText = `PAYROLL BATCH REJECTED\n\nBatch ID: #${id}\nFile: ${getDisplayFileName(original?.fileName, original?.companyName)}\nRecords: ${original?.records}\nCompany: ${original?.companyName}\nRejection Reason: ${rejectionReason || "No reason provided"}\n\n— NCS Payroll Service`;
        }

        try {
          const emailRes = await SendEmailWithAttachment3({
            userid: currentUserId,
            from: payrollAdminFromEmailId,
            recipient: submitterEmail,
            cc: '',
            subject,
            emailText,
            attachedfilename: "",
            fromname: payrollEmailFromName,
          });

          const isSuccess = emailRes?.data?.header?.callStatus === "1";
          const isFailure = emailRes?.payload?.callStatus !== "1";

          if (isSuccess) {
            emailStatusMsg = `Notification sent to ${submitterEmail}.`;
          } else if (isFailure) {
            emailStatusMsg = `Email failed: ${emailRes?.payload?.msg || "Failed to send email."}`;
          } else {
            emailStatusMsg = `Email status unknown for ${submitterEmail}.`;
          }
        } catch (e) {
          console.error("Email send error:", e);
          emailStatusMsg = `Email error: ${e?.message || "Unexpected error."}`;
        }
      }

      setAlert({
        open: true,
        severity: "success",
        header: "Success",
        message: `Batch #${id} → ${newStatus}.${emailStatusMsg ? ` ${emailStatusMsg}` : ""}`,
      });
    } catch (error) {
      if (error.message === INCORRECT_PIN_ERROR) {
        isPinError = true;
        setAlert({
          open: true,
          severity: "error",
          header: "Incorrect PIN",
          message: "The PIN you entered is wrong. Please try again.",
        });
        setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
        setShowPinPad(true);
        return;
      }
      setAlert({
        open: true,
        severity: "error",
        header: "Failed",
        message: "Status update failed.",
      });
      setBatches((prev) => prev.map((b) => (b.id === id ? original : b)));
    } finally {
      setSavingIds((prev) => {
        const s = new Set(prev);
        s.delete(id);
        return s;
      });
      if (!isPinError) {
        setShowPinPad(false);
        setPendingAction(null);
        setRejectionReason("");
      }
    }
    return;
  }
  } catch (error) {
       console.error("handlePinConfirm error:", error);
  }finally {
   isSubmittingRef.current = false;
    setPinProcessing(false);
  }
  
};
  const getStatusColor = (status) =>
    ({
      Open: "#e2e3e5",
      "Needs Review": "#fff3cd",
      "Approved for Processing": "#d4edda",
      Rejected: "#f8d7da",
      Completed: "#d1ecf1",
      Error: "#f5c6cb",
      Cancelled: "#d6d8db",
    })[status] || "#f8f9fa";

  const getStatusTextColor = (status) =>
    ({
      Open: "#383d41",
      "Needs Review": "#856404",
      "Approved for Processing": "#155724",
      Rejected: "#721c24",
      Completed: "#0c5460",
      Error: "#721c24",
      Cancelled: "#495057",
    })[status] || "#333";

  const handleDownloadCSV = async (batchId, fileName, batchCompanyName) => {
    try {
      const res = await ListTransFileRecs(batchId);

      if (res.callStatus !== "1") {
        setAlert({
          open: true,
          severity: "error",
          header: "Download Failed",
          message: "Could not load records for download.",
        });
        return;
      }

      const rawArray = res.payload?.record || [];
      const recordsArray = Array.isArray(rawArray)
        ? rawArray
        : rawArray
          ? [rawArray]
          : [];
      const allRecords = recordsArray
        .map((item) => item.Transfilerecs)
        .filter(Boolean);

      if (allRecords.length === 0) {
        setAlert({
          open: true,
          severity: "info",
          header: "No Data",
          message: "No records to download.",
        });
        return;
      }

      // Find the current batch to get status
      const currentBatch = filteredBatches.find((b) => b.id === batchId);
      const statusCode = currentBatch?.rawStatus || "";
      const statusLabel = currentBatch?.status || "Unknown";

      // ====================== MULTI-CURRENCY TOTAL CALCULATION ======================
      const totalsByCurrency = {};

      allRecords.forEach((r) => {
        const amount = parseFloat(r.amount || 0);
        const currency = (r.currency || "CAD").toUpperCase();

        if (!totalsByCurrency[currency]) totalsByCurrency[currency] = 0;
        totalsByCurrency[currency] += amount;
      });

      // Build single total message (only when Completed)
      let totalMessage = "";
      if (statusCode === "3") {
        const totalParts = Object.entries(totalsByCurrency).map(
          ([curr, total]) => {
            const formatted = total.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            return `${formatted} ${curr}`;
          },
        );

        totalMessage = `Total amount ${totalParts.join(" + ")} successfully deposited.`;
      }
      // =============================================================================

      const headers = [
        "First Name",
        "Last Name",
        "Email",
        "Phone",
        "Amount",
        "Currency",
        "Address Line 1",
        "Address Line 2",
        "Country",
        "State",
        "Zip Code",
        "Date of Birth",
        "Comment",
        "Purpose of Account",
        "Status",
        "Message",
      ];

      const rows = allRecords.map((r, index) => [
        (r.firstname || "").replace(/"/g, '""'),
        (r.lastname || "").replace(/"/g, '""'),
        (r.email || "").replace(/"/g, '""'),
        (r.phoneno || "").replace(/"/g, '""'),
        (r.amount || "0.00").replace(/"/g, '""'),
        (r.currency || "CAD").replace(/"/g, '""'),
        (r.address1 || "").replace(/"/g, '""'),
        (r.address2 || "").replace(/"/g, '""'),
        (r.country || "CA").replace(/"/g, '""'),
        (r.state || "").replace(/"/g, '""'),
        (r.zipcode || "").replace(/"/g, '""'),
        (r.birthdate || "").replace(/"/g, '""'),
        (decodeHtmlEntities(r.comment) || "").replace(/"/g, '""'), // FIX - NCS-1989
        (r.purposeofaccount || "").replace(/"/g, '""'),
        statusLabel.replace(/"/g, '""'),
        index === 0 ? totalMessage.replace(/"/g, '""') : "", // ← Single message only in first row
      ]);

      const csv = [
        headers.join(","),
        ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
      ].join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `${getDisplayFileName(fileName, batchCompanyName).replace(/\.csv$/i, "")}_records.csv`,
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setAlert({
        open: true,
        severity: "success",
        header: "Download Started",
        message: "CSV file is being downloaded.",
      });
    } catch (err) {
      console.error("Download failed:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Download Failed",
        message: "Error generating CSV file. Please try again.",
      });
    }
  };

  const cleanComment = (text) => {
    if (!text) return "—";

    const decoded = text
      .replace(/&amp;amp;/g, "&")
      .replace(/&amp;#0?39;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#0?39;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&nbsp;/g, " ");

    return decoded
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean)
      .join(" • ");
  };
  const cleanFileName = (fileName) => {
    if (!fileName) return "—";

    return fileName
      .replace(/&amp;#039;/g, "'") // ✅ decode encoded apostrophe first
      .replace(/&#039;/g, "'") // ✅ decode numeric entity
      .replace(/&#39;/g, "'") // ✅ decode short numeric entity
      .replace(/&amp;/g, "&") // ✅ decode &amp;
      .replace(/&/g, "_and_") // raw & → _and_
      .replace(/[()]/g, "") // remove parentheses
      .replace(/[^a-zA-Z0-9\s'_.-]/g, "") // ✅ ' preserved
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .trim();
  };
  const getDisplayFileName = (fileName, batchCompanyName) => {
    if (!fileName) return "—";
    const fixedFileName = fileName.replace(/BATCH_-/i, "BATCH-");
    const regexPattern = batchCompanyName
      .replace(/[^a-zA-Z0-9'\s]/g, "_+")
      .replace(/'/g, "_")
      .replace(/\s+/g, "_+");

    const displayCompany = batchCompanyName
      .replace(/[^a-zA-Z0-9'\s]/g, "_")
      .replace(/\s+/g, "_");

    try {
      const regex = new RegExp(regexPattern, "i");
      const restored = fixedFileName.replace(regex, displayCompany);
      return cleanFileName(restored);
    } catch (e) {
      return cleanFileName(fixedFileName);
    }
  };
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
        <CircularProgress size={48} />
      </Box>
    );
  }

  const companies = [
    "all",
    ...new Set(batches.map((b) => b.companyName)),
  ].sort();

  return (
    <div className="review-payroll-container">
      <div className="review-header">
        <h2>Payroll Batch Management </h2>
        <p>Review, edit individual records, and approve/reject batches</p>
      </div>

      <Box
        sx={{
          mb: 2,
          display: "flex",
          gap: 4,
          alignItems: "center",
          flexWrap: "wrap",
          p: 2,
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", color: "#5523D2" }}
          >
            Company:
          </Typography>
          <Select
            size="small"
            value={companyFilter}
            onChange={(e) => setCompanyFilter(e.target.value)}
            sx={{
              minWidth: 180,
              backgroundColor: "white",
              borderColor: "#5523D2",
              "& .MuiSelect-select": {
                py: 1,
                fontSize: "0.9rem",
                color: "#333",
              },
              borderRadius: 1,
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            {companies.map((comp) => (
              <MenuItem key={comp} value={comp}>
                {comp}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", color: "#5523D2" }}
          >
            Status:
          </Typography>
          <Select
            size="small"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            sx={{
              minWidth: 140,
              backgroundColor: "white",
              borderColor: "#5523D2",
              "& .MuiSelect-select": {
                py: 1,
                fontSize: "0.9rem",
                color: "#333",
              },
              borderRadius: 1,
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="Needs Review">Review</MenuItem>
            <MenuItem value="Rejected">Rejected</MenuItem>
            <MenuItem value="Completed">Completed</MenuItem>
            <MenuItem value="Approved for Processing">
              Approved for Processing
            </MenuItem>
            <MenuItem value="Cancelled">Cancelled</MenuItem>
            <MenuItem value="Error">Error</MenuItem>
          </Select>
        </Box>
      </Box>

      <div className="review-table-wrapper">
        {filteredBatches.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8, color: "#666" }}>
            No payroll batches found.
          </Box>
        ) : (
          <table className="review-table">
            <thead>
              <tr>
                <th>Company</th>
                <th>Batch ID</th>
                <th>Agent ID</th>
                <th>File</th>
                <th>Total Amount</th>

                <th>Uploaded</th>
                <th>Scheduled Time</th>
                <th>Notes</th>

                <th>Actions</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredBatches.map((batch) => (
                <tr key={batch.id}>
                  <td>
                    <strong>{batch.companyName}</strong>
                  </td>
                  <td>
                    <strong>{batch.id}</strong>
                  </td>
                  <td>{batch.agentId}</td>

                  <td>
                    <code>
                      {getDisplayFileName(batch.fileName, batch.companyName)}
                    </code>
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      fontWeight: "500",
                      color: "#1976d2",
                    }}
                  >
                    {batch.totalAmountDisplay}
                  </td>

                  <td>{batch.uploadedAt}</td>
                  <td>{batch.scheduledTime}</td>
                  <td style={{ fontSize: "0.85rem", maxWidth: "340px" }}>
                    {batch.notes}
                  </td>
                  {/* <td>
                    <span
                      className="status-badge"
                      style={{
                        backgroundColor: getStatusColor(batch.status),
                        color: getStatusTextColor(batch.status),
                      }}
                    >
                      {batch.status}
                    </span>
                  </td> */}
                  <td>
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => openRecordEditor(batch)}
                        sx={{ mr: 1, backgroundColor: "#5523D2" }}
                      >
                        View Records
                      </Button>

                      {/* <Tooltip title="Download CSV">
                        <IconButton
                          size="small"
                          onClick={() => handleDownloadCSV(batch.id, batch.fileName, batch.companyName)}
                          sx={{ color: "#145388" }}
                        >
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip> */}
                    </Box>
                  </td>

                  <td>
                    {savingIds.has(batch.id) ? (
                      <CircularProgress size={20} />
                    ) : batch.status === "Review in Progress" ||
                      batch.status === "Completed" ||
                      batch.status === "Error" ||
                      batch.status === "Cancelled" ||
                      // batch.status === "Rejected" ||
                      (batch.status === "Approved for Processing" &&
                        new Date(batch.scheduledTime) <= new Date()) ? (
                      <span style={{ fontWeight: "bold", color: "#856404" }}>
                        {batch.status}{" "}
                        {/* Shows "Review in Progress" or "Approved for Processing" */}
                      </span>
                    ) : (
                      <Tooltip
                        title={
                          batch.status === "Approved for Processing"
                            ? "Cancel available only for this status"
                            : batch.status === "Rejected" ||
                                batch.status === "Review in Progress"
                              ? "Change status"
                              : "Change status"
                        }
                        arrow
                      >
                        <span>
                          <select
                            value={batch.status}
                            onChange={(e) =>
                              requestStatusChange(batch.id, e.target.value)
                            }
                            className="status-select"
                          >
                            <option value={batch.status} disabled hidden>
                              {batch.status}
                            </option>

                            {/* {batch.status !== "Approved for Processing" && (
                              <option value="Approved for Processing">
                                Approve
                              </option>
                            )}

                            {batch.status !== "Approved for Processing" &&
                              batch.status !== "Rejected" && (
                                <option value="Rejected">Reject</option>
                              )}

                            {batch.status === "Approved for Processing" &&
                              new Date(batch.scheduledTime) > new Date() && (
                                <option value="Cancelled">Cancel</option>
                              )}
{batch.status === "Rejected" && (
  <option value="Approved for Processing">Approve</option>
)} */}


{/* Approve — for all statuses except "Approved for Processing" and "Rejected" */}
{batch.status !== "Approved for Processing" && 
 batch.status !== "Rejected" && (
  <option value="Approved for Processing">Approve</option>
)}

{/* Reject — for statuses that aren't already Approved or Rejected */}
{batch.status !== "Approved for Processing" &&
 batch.status !== "Rejected" && (
  <option value="Rejected">Reject</option>
)}

{/* Cancel — only when Approved and scheduled time is in future */}
{batch.status === "Approved for Processing" &&
 new Date(batch.scheduledTime) > new Date() && (
  <option value="Cancelled">Cancel</option>
)}

{/* Re-approve — only for Rejected batches */}
{batch.status === "Rejected" && (
  <option value="Approved for Processing">Approve</option>
)}

                          </select>
                        </span>
                      </Tooltip>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Modal open={!!selectedBatch} onClose={() => setSelectedBatch(null)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: 1650,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            overflow: "auto",
          }}
        >
          {selectedBatch && (
            <>
              <h2>
                Editing Batch #{selectedBatch.id} —{" "}
                {getDisplayFileName(
                  selectedBatch.fileName,
                  selectedBatch.companyName,
                )}
              </h2>
              <p>
                <strong>{records.length}</strong> record
                {records.length !== 1 && "s"} • Click Edit to modify
              </p>

              {recordsLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 8,
                  }}
                >
                  <CircularProgress size={48} />
                  <Typography sx={{ ml: 2, color: "#666" }}>
                    Loading records...
                  </Typography>
                </Box>
              ) : records.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 8, color: "#999" }}>
                  No records found in this batch.
                </Box>
              ) : (
                <>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "0.9rem",
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#5523D2", color: "white" }}>
                        <th style={{ padding: "12px" }}>First Name</th>
                        <th style={{ padding: "12px" }}>Last Name</th>
                        <th style={{ padding: "12px" }}>Email</th>
                        <th style={{ padding: "12px" }}>Phone</th>
                        <th style={{ padding: "12px" }}>Amount</th>
                        <th style={{ padding: "12px" }}>Currency</th>
                        <th style={{ padding: "12px" }}>Address</th>
                        <th style={{ padding: "12px" }}>Country</th>
                        <th style={{ padding: "12px" }}>DOB</th>
                        <th style={{ padding: "12px" }}>Comment</th>
                        <th style={{ padding: "12px" }}>Puporse of Account</th>
                        <th style={{ padding: "12px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {records.map((rec) => (
                        <tr
                          key={rec.id}
                          style={{ borderBottom: "1px solid #eee" }}
                        >
                          {editingRecId === rec.id ? (
                            <>
                              <td>
                                <TextField
                                  size="small"
                                  value={editForm.firstname || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      firstname: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editForm.lastname || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      lastname: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editForm.email || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      email: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editForm.phoneno || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      phoneno: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  type="number"
                                  step="0.01"
                                  value={editForm.amount || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      amount: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <Select
                                  size="small"
                                  value={editForm.currency || "CAD"}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      currency: e.target.value,
                                    })
                                  }
                                >
                                  <MenuItem value="CAD">CAD</MenuItem>
                                  <MenuItem value="USD">USD</MenuItem>
                                  <MenuItem value="EUR">EUR</MenuItem>
                                </Select>
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={`${editForm.address1 || ""} ${editForm.address2 || ""}`.trim()}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    const parts = val.split(" ");
                                    setEditForm({
                                      ...editForm,
                                      address1: parts.slice(0, 8).join(" "),
                                      address2: parts.slice(8).join(" "),
                                    });
                                  }}
                                  placeholder="Full address"
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editForm.country || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      country: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  type="date"
                                  value={editForm.birthdate || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      birthdate: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <TextField
                                  size="small"
                                  value={editForm.comment || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      comment: e.target.value,
                                    })
                                  }
                                />
                              </td>
                              {/* ✅ ADDED: Purpose of Account column was missing in edit mode */}
                              {/* <td>
                                <TextField
                                  size="small"
                                  value={editForm.purposeofaccount || ""}
                                  onChange={(e) =>
                                    setEditForm({
                                      ...editForm,
                                      purposeofaccount: e.target.value,
                                    })
                                  }
                                />
                              </td> */}
                              <td>
  <Select
    size="small"
    value={editForm.purposeofaccount || ""}
    onChange={(e) =>
      setEditForm({
        ...editForm,
        purposeofaccount: e.target.value,
      })
    }
    displayEmpty
    error={
      editForm.purposeofaccount !== "" &&
      !["1", "2", "3"].includes(editForm.purposeofaccount)
    }
    sx={{ minWidth: 80 }}
  >
    <MenuItem value="" disabled>Select</MenuItem>
    <MenuItem value="1">1</MenuItem>
    <MenuItem value="2">2</MenuItem>
    <MenuItem value="3">3</MenuItem>
  </Select>
</td>
                              {/* ✅ Save/Cancel now correctly in the Action column */}
                              <td>
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="success"
                                  onClick={saveRecord}
                                >
                                  Save
                                </Button>
                                <Button
                                  size="small"
                                  onClick={() => setEditingRecId(null)}
                                  sx={{ ml: 1 }}
                                >
                                  Cancel
                                </Button>
                              </td>
                            </>
                          ) : (
                            <>
                              <td style={{ padding: "10px" }}>
                                {rec.firstname}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.lastname}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.email || "—"}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.phoneno || "—"}
                              </td>
                              <td
                                style={{ padding: "10px", fontWeight: "bold" }}
                              >
                                {rec.amount}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.currency}
                              </td>
                              <td style={{ padding: "10px" }}>
                                {rec.address1} {rec.address2}
                              </td>
                              <td style={{ padding: "10px" }}>{rec.country}</td>
                              <td style={{ padding: "10px" }}>
                                {rec.birthdate || "—"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  maxWidth: "200px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={rec.comment}
                              >
                                {cleanComment(rec.comment)}
                              </td>
                              <td
                                style={{ padding: "10px", textAlign: "center" }}
                              >
                                {rec.purposeofaccount}
                              </td>
                              <td style={{ padding: "10px" }}>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => startEdit(rec)}
                                >
                                  Edit
                                </Button>
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* TOTAL AMOUNT SECTION */}
                  <Box
                    sx={{
                      mt: 3,
                      p: 3,
                      backgroundColor: "#f0f4ff",
                      borderRadius: 2,
                      border: "1px solid #c5d4ff",
                      textAlign: "right",
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" color="#1a237e">
                      Total Amount
                    </Typography>

                    {isSingleCurrency ? (
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        color="#1976d2"
                        sx={{ mt: 1 }}
                      >
                        {grandTotal.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        {mainCurrency}
                      </Typography>
                    ) : (
                      <>
                        {Object.entries(totalsByCurrency).map(
                          ([curr, total]) => (
                            <Typography
                              key={curr}
                              variant="h6"
                              sx={{ mt: 0.5 }}
                            >
                              {total.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {curr}
                            </Typography>
                          ),
                        )}
                        {/* <Typography variant="body1" sx={{ mt: 2, fontWeight: "bold", borderTop: "1px solid #ddd", pt: 1 }}>
                          Grand Total: {grandTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Typography> */}
                      </>
                    )}

                    {/* <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      Across {records.length} record{records.length !== 1 ? "s" : ""}
                    </Typography> */}
                  </Box>
                </>
              )}

              <Box sx={{ mt: 4, textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setSelectedBatch(null)}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
{showPinPad && (
  <PinPad
    show={showPinPad}
    handleConfirm={handlePinConfirm}
    onClick={() => {
      setShowPinPad(false);
      setPendingAction(null);
      setPendingRecordSave(null);  // ← add this
    }}
     loading={pinProcessing}
  />
)}

      <Modal
        open={rejectModalOpen}
        onClose={() => {
          setRejectModalOpen(false);
          setPendingAction(null);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom color="error">
            Confirm Rejection
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to reject Batch #{pendingAction?.id}?
          </Typography>

          <TextField
            label="Rejection Reason (required)"
            multiline
            rows={4}
            fullWidth
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            error={rejectionReason.trim() === ""}
            helperText={
              rejectionReason.trim() === "" ? "Reason is required" : ""
            }
            sx={{ mb: 3 }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setRejectModalOpen(false);
                setPendingAction(null);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              disabled={rejectionReason.trim() === ""}
              onClick={() => {
                setRejectModalOpen(false);
                setShowPinPad(true); // Proceed to PIN with reason
              }}
            >
              Confirm Rejection
            </Button>
          </Box>
        </Box>
      </Modal>

      <CustomAlert
        severity={alert.severity}
        show={alert.open}
        header={alert.header}
        message={alert.message}
        onClick={() => setAlert({ ...alert, open: false })}
        autoclose={alert.severity === "success"}
      />
    </div>
  );
}

